import { createElementFromHTML, getOffset, getParent, smoothScrollTo, loadScript } from '../../js/helper';
import { AjaxLoader } from '../../js/ajax-loader';
import { sendTracking, getTrackingData, bindTrackingClick } from '../../js/tracking';

class FormHandler {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-form',
            fieldAttr: 'data-input',
            resultAttr: 'result',
            showAttr: 'show',
            showNameSpaceAttr: 'data-shownamespace',
            countrySelectAttr: 'data-countryselect',
            autoSubmitAttr: 'submit',
            loader: null,
            onSubmitted: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$formHandler = element;
        this.$header = document.querySelector('[data-header="root"]');

        if (this.$formHandler.querySelector('form') === null) {
            return;
        }

        if (this.settings.loader !== null) {
            this.$loader = createElementFromHTML(this.settings.loader);
        }
    }

    initialize () {
        this.initFormFields();
        this.setEvents();
    }

    handleShowHideElements ($group) {
        const $$inputs = $group.querySelectorAll('input');

        const inputValues = [];

        let namespace = 'is';
        if ($group.getAttribute(this.settings.showNameSpaceAttr)) {
            namespace = $group.getAttribute(this.settings.showNameSpaceAttr);
        }

        const switchDisabled = ($elements, status) => {
            const $$inputs = $elements.querySelectorAll('input');
            if ($$inputs.length > 0) {
                $$inputs.forEach((input) => {
                    if (input.type === 'radio' || input.type === 'checkbox' || input.type === 'text') {
                        input.disabled = status;
                    }
                });
            }
        };

        const switchView = (val, namespace, visible) => {
            const $$elements = this.$formHandler.querySelectorAll('.' + namespace + '--' + val);

            for (let i = 0; i < $$elements.length; i++) {
                if (visible === true) {
                    $$elements[i].classList.add('is--visible');
                    switchDisabled($$elements[i], false);
                } else {
                    $$elements[i].classList.remove('is--visible');
                    switchDisabled($$elements[i], true);
                }
            }
        };

        for (let s = 0; s < $$inputs.length; s++) {
            const $input = $$inputs[s];

            inputValues.push($input.value);

            $input.addEventListener('change', () => {
                if ($input.value) {
                    for (let i = 0; i < inputValues.length; i++) {
                        switchView(inputValues[i], namespace, false);

                        if (i === inputValues.length - 1) {
                            switchView($input.value, namespace, true);
                        }
                    }
                }
            });

            if ($input.getAttribute('checked')) {
                for (let i = 0; i < inputValues.length; i++) {
                    switchView(inputValues[i], namespace, false);

                    if (i === inputValues.length - 1) {
                        switchView($input.value, namespace, true);
                    }
                }
            }
        }
    }

    initFormFields () {
        const $$fields = this.$formHandler.querySelectorAll('[' + this.settings.fieldAttr + ']');
        if ($$fields.length > 0) {
            import('./form-input').then(({ FormInput }) => {
                for (let i = 0; i < $$fields.length; i++) {
                    const $field = $$fields[i];
                    const formAPI = new FormInput($field);
                    $field.API = formAPI;
                }
            });
        }

        const $$showHandlers = this.$formHandler.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.showAttr + '"]');
        if ($$showHandlers.length > 0) {
            for (let j = 0; j < $$showHandlers.length; j++) {
                const $showHandler = $$showHandlers[j];

                this.handleShowHideElements($showHandler);
            }
        }

        const $$countrySelectHandlers = this.$formHandler.querySelectorAll('[' + this.settings.countrySelectAttr + ']');
        if ($$countrySelectHandlers.length > 0) {
            import('./country-select').then(({ CountrySelect }) => {
                for (let i = 0; i < $$countrySelectHandlers.length; i++) {
                    const $countrySelectHandler = $$countrySelectHandlers[i];

                    const countrySelectHandlerAPI = new CountrySelect($countrySelectHandler, {
                        loader: this.settings.loader
                    });
                    $countrySelectHandler.API = countrySelectHandlerAPI;
                }
            });
        }

        const $$damageMarkers = this.$formHandler.querySelectorAll('[data-damagemarker="root"]');
        if ($$damageMarkers.length > 0) {
            import('../damage-marker/damage-marker').then(({ DamageMarker }) => {
                for (let i = 0; i < $$damageMarkers.length; i++) {
                    const $damageMarker = $$damageMarkers[i];

                    const damageMarkerAPI = new DamageMarker($damageMarker, {
                        loader: this.settings.loader
                    });
                    $damageMarker.API = damageMarkerAPI;
                }
            });
        }

        const $$uploaders = this.$formHandler.querySelectorAll('[data-uploader="root"]');
        if ($$uploaders.length > 0) {
            import('../uploader/uploader').then(({ Uploader }) => {
                for (let i = 0; i < $$uploaders.length; i++) {
                    const $uploader = $$uploaders[i];

                    const uploaderAPI = new Uploader($uploader, {
                        loader: this.settings.loader
                    });
                    $uploader.API = uploaderAPI;
                }
            });
        }

        const $idForm = this.$formHandler.querySelector('[data-idform="root"]');

        if ($idForm) {
            import('../../modules/product-support/idform').then(({ IdForm }) => {
                const idForm = new IdForm($idForm, { // eslint-disable-line
                    loader: window.OPTIONS.loader
                });
            });
        }

        const $$autoSubmits = this.$formHandler.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.autoSubmitAttr + '"]');
        for (let i = 0; i < $$autoSubmits.length; i++) {
            const $autoSubmit = $$autoSubmits[i];

            if ($autoSubmit.tagName.toLowerCase() === 'select') {
                const apiCheckInterval = window.setInterval(() => {
                    if (typeof $autoSubmit.API !== 'undefined') {
                        clearInterval(apiCheckInterval);
                        const autoSubmitAPI = $autoSubmit.API;
                        autoSubmitAPI.on('selectr.change', () => {
                            const $form = getParent($autoSubmit, 'form');

                            if ($form) {
                                if (this.$loader) {
                                    const $parent = getParent($autoSubmit, '.form__element');
                                    $parent.appendChild(this.$loader);
                                }
                                this.submitForm($form, true);
                            }
                        });
                    }
                }, 100);
            }
        }

        const $recaptcha = this.$formHandler.querySelector('.recaptcha');

        if ($recaptcha) {
            const siteKey = $recaptcha.getAttribute('data-key');

            if (typeof window.grecaptcha !== 'undefined') {
                if (siteKey) {
                    if (typeof window.grecaptcha !== 'undefined' && $recaptcha.childElementCount === 0) { // eslint-disable-line
                        window.grecaptcha.ready(() => {
                            window.grecaptcha.render($recaptcha, {
                                sitekey: siteKey,
                                size: 'invisible',
                                callback: () => {
                                    const $form = this.$formHandler.querySelector('form');
                                    this.submitForm($form);
                                }
                            });
                        });
                    }
                }
            } else {
                let scriptIsLoaded = false;

                const interval = setInterval(() => {
                    if (typeof window.grecaptcha !== 'undefined' && $recaptcha.childElementCount > 0) {
                        scriptIsLoaded = true;
                        clearInterval(interval);
                    }

                    if (typeof window.grecaptcha !== 'undefined' && $recaptcha.childElementCount === 0) { // eslint-disable-line
                        scriptIsLoaded = true;
                        window.grecaptcha.ready(() => {
                            window.grecaptcha.render($recaptcha, {
                                sitekey: siteKey,
                                size: 'invisible',
                                callback: () => {
                                    const $form = this.$formHandler.querySelector('form');
                                    this.submitForm($form);
                                }
                            });
                        });
                        clearInterval(interval);
                    } else {
                        if (!scriptIsLoaded) {
                            const lang = document.documentElement.getAttribute('lang');
                            loadScript('//www.recaptcha.net/recaptcha/api.js?hl=' + lang);
                        }
                    }
                }, 500);
            }
        }
    }

    submitForm ($form, autosubmit) {
        if ($form === null) {
            return;
        }

        if (!autosubmit) {
            const $button = $form.querySelector('[type="submit"]');
            if ($button && this.$loader) {
                $button.setAttribute('disabled', true);
                $button.appendChild(this.$loader);
            }
        }

        const formAction = $form.getAttribute('action');
        const formMethod = $form.getAttribute('method');
        const formData = new FormData($form);

        this.formResult = new AjaxLoader(formAction, {
            requestMethod: formMethod,
            requestData: formData,
            onSuccess: (resultText) => {
                let resultData = null;
                let jsonData = null;

                try {
                    jsonData = JSON.parse(resultText);
                    resultData = jsonData.html;

                    if (typeof jsonData.success !== 'undefined') {
                        if (jsonData.success) {
                            const formSuccessPage = document.querySelector('[data-form-success-page]');

                            if (formSuccessPage) {
                                window.location.href = formSuccessPage.dataset.formSuccessPage;
                            }
                        }
                    }
                } catch (e) {
                    resultData = resultText;
                }

                const $result = createElementFromHTML(resultData);
                const $resultContent = $result.querySelector('[data-form]');
                this.$formHandler.innerHTML = $resultContent.innerHTML;

                let positionTop = this.$formHandler.offsetTop;

                const $errorMessage = this.$formHandler.querySelector('.form__errors');
                if ($errorMessage) {
                    positionTop = getOffset($errorMessage).top;
                }

                const $formResult = this.$formHandler.querySelector('[' + this.settings.initAttr + '="' + this.settings.resultAttr + '"]');
                if ($formResult) {
                    positionTop = $formResult.offsetTop;
                }

                if (this.$header) {
                    positionTop = positionTop - this.$header.offsetHeight;
                }

                // send tracking for submit
                if ($form.getAttribute('data-notracking') === null) {
                    const $tracking = this.$formHandler.querySelector('[data-tracking]');
                    if ($tracking) {
                        const trackingData = getTrackingData($tracking);
                        sendTracking(trackingData);
                    }

                    const $datalayerTracking = this.$formHandler.querySelector('[data-tracking-datalayer]');

                    if ($datalayerTracking) {
                        const data = JSON.parse($datalayerTracking.dataset.trackingDatalayer);

                        if (typeof window.queryParamsCode !== 'undefined') {
                            data.dt_swiss_id = window.queryParamsCode;
                        }
                        if (typeof window.queryParamsSecondCode !== 'undefined') {
                            data.dt_swiss_id2 = window.queryParamsSecondCode;
                        }
                        if (typeof window.codeStatus !== 'undefined') {
                            data.dt_swiss_id_status = window.codeStatus;
                        }
                        if (typeof window.secondCodeStatus !== 'undefined') {
                            data.dt_swiss_id2_status = window.secondCodeStatus;
                        }
                        window.dataLayer.push(data);
                    }
                }

                bindTrackingClick(this.$formHandler);

                window.setTimeout(() => {
                    smoothScrollTo(0, positionTop, 500);
                }, 250);

                this.initFormFields();

                if (typeof this.settings.onSubmitted === 'function') {
                    this.settings.onSubmitted(this.$formHandler);
                }
            }
        });
    }

    setEvents () {
        this.$formHandler.addEventListener('submit', (e) => {
            if (e.target.tagName.toLowerCase() === 'form' && (typeof window.stopFormSubmit === 'undefined' || window.stopFormSubmit === false)) {
                if (typeof window.grecaptcha !== 'undefined') {
                    window.grecaptcha.execute();
                } else {
                    this.submitForm(e.target);
                }
            }
            e.preventDefault();
        });
    }
}

export { FormHandler };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$forms = $context.querySelectorAll('[data-form="root"]');

        if ($$forms.length > 0) {
            for (let i = 0; i < $$forms.length; i++) {
                const $form = new FormHandler($$forms[i], {
                    loader: window.OPTIONS.loader
                });
                $form.initialize();
            }
        }
    }
});
